export const enum RootRoutePath {
  Home = '/',
  NotFound = '*',
}

const indexRoutePath = '';

export const enum HomeRoutePath {
  StudentObserver = 'student-observer',
  AdminSchoolLinks = 'admin-school-links',
  SchoolLinksManager = 'school-links-manager',
  Dashboard = 'dashboard',
  Subjects = 'subjects',
  Progress = 'progress',
  Library = 'library',
  Reports = 'reports',
  ParentHelper = 'parent-helper',
  CookiesPolicy = 'cookies-policy',
  PrivacyNotice = 'privacy-notice',
  TermsOfUse = 'terms-of-use',
  Calendar = 'calendar',
  SchoolLinks = 'school-links',
}

export const enum DashboardRoutePath {
  AllUpcomingAssignments = 'all-upcoming-assignments',
}

export const enum AllUpcomingAssignmentsRoutePath {
  Assignments = 'assignments',
  AssignmentDetails = 'assignments/:assignmentId',
}

export const enum SubjectsRoutePath {
  SubjectDetails = ':subjectId',
  Overview = indexRoutePath,
  Assignments = 'assignments',
  AssignmentDetails = 'assignments/:assignmentId',
  Resources = 'resources',
  Syllabus = 'syllabus',
}

// TODO: need to pick common solution for indexed routes
export const enum AssignmentsRoutePath {
  Overview = indexRoutePath,
  Results = 'results',
}

export const enum ProgressRoutePath {
  Subject = 'subject/:subjectId',
}

export const enum RoutePath {
  StudentObserver = `${RootRoutePath.Home}${HomeRoutePath.StudentObserver}`,
  AdminSchoolLinks = `${RootRoutePath.Home}${HomeRoutePath.AdminSchoolLinks}`,
  SchoolLinksManager = `${RootRoutePath.Home}${HomeRoutePath.SchoolLinksManager}`,
  Dashboard = `${RootRoutePath.Home}${HomeRoutePath.Dashboard}`,
  UpcomingAssignments = `${RootRoutePath.Home}${HomeRoutePath.Dashboard}/${DashboardRoutePath.AllUpcomingAssignments}/${AllUpcomingAssignmentsRoutePath.Assignments}`,
  UpcomingAssignmentDetails = `${RootRoutePath.Home}${HomeRoutePath.Dashboard}/${DashboardRoutePath.AllUpcomingAssignments}/${AllUpcomingAssignmentsRoutePath.AssignmentDetails}`,
  UpcomingAssignmentDetailsResults = `${RootRoutePath.Home}${HomeRoutePath.Dashboard}/${DashboardRoutePath.AllUpcomingAssignments}/${AllUpcomingAssignmentsRoutePath.AssignmentDetails}/${AssignmentsRoutePath.Results}`,
  SubjectDetails = `${RootRoutePath.Home}${HomeRoutePath.Subjects}/${SubjectsRoutePath.SubjectDetails}`,
  SubjectOverview = `${RootRoutePath.Home}${HomeRoutePath.Subjects}/${SubjectsRoutePath.SubjectDetails}/${SubjectsRoutePath.Overview}`,
  Assignments = `${RootRoutePath.Home}${HomeRoutePath.Subjects}/${SubjectsRoutePath.SubjectDetails}/${SubjectsRoutePath.Assignments}`,
  AssignmentDetails = `${RootRoutePath.Home}${HomeRoutePath.Subjects}/${SubjectsRoutePath.SubjectDetails}/${SubjectsRoutePath.AssignmentDetails}`,
  AssignmentDetailsResults = `${RootRoutePath.Home}${HomeRoutePath.Subjects}/${SubjectsRoutePath.SubjectDetails}/${SubjectsRoutePath.AssignmentDetails}/${AssignmentsRoutePath.Results}`,
  Progress = `${RootRoutePath.Home}${HomeRoutePath.Progress}`,
  SchoolLinks = `${RootRoutePath.Home}${HomeRoutePath.SchoolLinks}`,
  ProgressSubject = `${RootRoutePath.Home}${HomeRoutePath.Progress}/${ProgressRoutePath.Subject}`,
  PrivacyNotice = `${RootRoutePath.Home}${HomeRoutePath.PrivacyNotice}`,
  CookiesPolicy = `${RootRoutePath.Home}${HomeRoutePath.CookiesPolicy}`,
  TermsOfUse = `${RootRoutePath.Home}${HomeRoutePath.TermsOfUse}`,
  Calendar = `${RootRoutePath.Home}${HomeRoutePath.Calendar}`,
}
